import { render } from "./UserCard.vue?vue&type=template&id=01758df3&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"

import "./UserCard.vue?vue&type=style&index=0&id=01758df3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01758df3"

export default script